<template>
<main class="registration-container">
  <div class="registration">
    <Logo />

    <h1 class="registration__title">Skapa ett konto</h1>
    <p>Du har nu tagit ditt första steg mot mindre pensionsångest! Ditt framtida du kommer att tacka dig.</p>

    <section class="registration__middle">
      <h2 class="registration__subtitle">Välj metod för registrering</h2>

      <div class="registration__signin">
          <div class="login__tabs">
          <Tabs
              v-for="tab in tabs"
              :key="tab.id"
              :tab="tab"
          />
          </div>

          <LoginForm :tab="tabs.find(tab=>tab.isActive)" :tabs="tabs" />
      </div>
    </section>

    <!-- <RegistrationFooter /> -->
  </div>
</main>
</template>

<script>
import { Tabs, LoginForm } from '@/components/';
import Logo from '../components/elements/Logo';
import RegistrationFooter from '../components/elements/RegistrationFooter';

export default {
  name: 'Registration',
  components: { Tabs, LoginForm, Logo, RegistrationFooter, },
  data () {
    return {
      tabs: [
        {
          id:1,
          title: 'Mobilt BankID',
          isActive: true,
          btn:"Logga in"
        },
        {
          id:2,
          title: 'BankID',
          isActive: false,
          btn:'Öppna BankID-applikationen'
        },
        {
          id:3,
          title: 'QR kod',
          isActive: false,
          btn:false
        }
      ], 
    }
  },
}
</script>